const routes = [{
        path: '/login',
        name: 'login',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/login/index'], resolve) //登录页
    }, {
        path: '/',
        name: 'logout',
        meta: { keepAlive: false, },
        component: resolve => require(['../pages/logout/index'], resolve) //退出页
    }, {
        path: '/teacherlogin',
        name: 'teacherlogin',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/teacherLogin/index'], resolve) //教师登录页
    }, {
        path: '/home',
        name: 'home',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/home/index'], resolve) //首页
    },
    {
        path: '/boutiqueCase',
        name: 'boutiquecase',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/boutiquecase/index'], resolve) //精品案例页
    },
    {
        path: '/caseLibrary',
        name: 'caseLibrary',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/caseLibrary/index'], resolve) //教学案例库
    }, {
        path: '/caseLibraryHome',
        name: 'caseLibraryHome',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/caseLibrary/home'], resolve) //教学案例库首页
    },
    {
        path: '/practicalResourceCaseLibrary',
        name: 'practicalResourceCaseLibrary',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/practicalResourceCaseLibrary/index'], resolve) //实用资源库
    },
    {
        path: '/caseStudies',
        name: 'caseStudies',
        meta: { keepAlive: true },
        component: resolve => require(['../pages/caseStudies/index'], resolve) //案例研究辅助平台
    },

    {
        path: '/book',
        name: 'book',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/book/index'], resolve) // 书本详情
    }, {
        path: '/article1',
        name: 'article1',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/article/article'], resolve) // 文章页1
    }, {
        path: '/article',
        name: 'article',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/article/index'], resolve) // 文章页
    }, {
        path: '/productsAndServices',
        name: 'productsAndServices',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/productsAndServices/index'], resolve) // 产品与服务
    }, {
        path: '/search',
        name: 'search',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/search/index'], resolve) // 检索页面
    }, {
        path: '/userCenter',
        name: 'userCenter',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/userCenter/index'], resolve) //用户专区
    }, {
        path: '/zhbd',
        name: 'zhbd',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/zhbd/index'], resolve) //账号绑定
    }, {
        path: '/gyal',
        name: 'gyal',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/gyal/index'], resolve) //国研案例
    }, {
        path: '/bhal',
        name: 'bhal',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/bhal/index'], resolve) //北航案例
    }, {
        path: "/exclusive",
        name: 'exclusive',
        meta: { keepAlive: false },
        component: resolve => require(['../pages/exclusive/index'], resolve) //北航案例公告
    }
]

export default routes;


// WEBPACK FOOTER //
// ./src/router/routes.js